export default function () {
  this.doLoad()
}



// WEBPACK FOOTER //
// ./src/app/patient/profile-professional/components/schedule/resources/mounted.js